import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import OrderModemForm from '../forms/OrderModemForm'
import globals from '../globals'

const OrderModemModule = (props) => {
    return (
        <div className='order-modem module' style={{ overflow: 'visible' }}>
            <div id='sub-navigation' />{/* This is for scrollToNav method in FormHOC */}
            <Heading title='Order a pre-configured modem/router' />
            <ModuleWithLoader isLoaded={props.isLoaded} hasError={props.hasError}>
                <div className='row p-4'>
                    {props.broadbandServices.length > 0
                        ? <React.Fragment>
                            <div className='col-12 col-md-8 offset-md-2 text-center'>
                                <p>As nbn™ and fibre networks now use multiple technologies such as VDSL2, we strongly recommend that you use our recommended WiFi modems. Our modems are configured in advance and certified by Exetel to work with the specific technology at your place. We are also able to provide full remote support.</p>
                                <p>We will let you know via email and text when your modem has been shipped and how you can track delivery.</p>
                            </div>
                            <div className='col-12'>
                                <OrderModemForm
                                    broadbandServices={props.broadbandServices}
                                    voipServices={props.voipServices}
                                    handleSuccess={() => globals.pushEvent('OrderModemSubmit')}
                                />
                            </div>
                          </React.Fragment>
                        : <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>Your account does not not currently have any active broadband services.</p>
                        </div>}
                </div>
            </ModuleWithLoader>
        </div>
    )
}

OrderModemModule.propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    broadbandServices: PropTypes.array.isRequired,
    voipServices: PropTypes.array.isRequired
}

export default OrderModemModule



// WEBPACK FOOTER //
// ./resources/js/modules/OrderModemModule.js